export function parseResponse (response) {
  let json = response.json();
  if (response.status >= 200 && response.status < 300) {
    return json;
  } else {
    return json.then(err => Promise.reject(err));
  }
}



// WEBPACK FOOTER //
// ./src/utils/handle-fetch-response.js